<template>
  <div class="admin-home">
    <!--头部概览数据 -->
    <ul class="head-data">
        <li v-for="item in headData" :key="item.name" class="head-item">
            <div class="head-content">
                <div class="head-icon">
                    <i :class="item.icon" class="iconfont"></i>
                </div>
                <div class="head-name">
                    <p class="head-name-text">{{item.name}}</p>
                    <p class="head-value-text" :class="{'text-high':chartData[item.key]>0}">
                        <span v-if="item.valueType=='money'">{{ chartData[item.key] | formatMoney}}</span>
                        <span v-else>{{ chartData[item.key] }}</span>
                    </p>
                </div>
            </div>
            <div class="head-img">
                <img v-lazy="'/images/public/xl_3.jpg'" height="40px" class="mr-1 mt-2" alt="未认证" />
            </div>
        </li>
    </ul>
    <!--统计数据概览图 -->
    <div class="data-chart">
        <div class="data-chart-title">统计数据</div>
        <div class="data-chart-list-box">
            <ul  class="data-chart-list">
                <li v-for="(item,index) in dataChart" :key="item.name" class="data-chart-item" :class="{'active':currentChart==index}" @click="changeChart(index)">
                    <div class="data-chart-name">{{item.name}}</div>
                </li>
            </ul>
            <!-- 时间范围选择器 -->
            <el-date-picker
                v-model="monthRange"
                value-format="yyyy-MM-dd"
                type="monthrange"
                size="small"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                class="date-picker"
                @change="handleMonthChange"
            />
            <ul class="data-chart-list">
                <li v-for="(item,index) in timeRange" :key="item.name" class="time-range-item" :class="{'active':timeRangeIndex==index}" @click="changeTimeRange(index)">
                    <div class="time-range-name">{{item.name}}</div>
                </li>
            </ul>
        </div>    
        <div class="data-chart-total">
            <p>总{{dataChart[currentChart].name}}数</p>
            <h2>
                <span v-if="dataChart[currentChart].valueType=='money'">{{ chartData[dataChart[currentChart].key]| formatMoney}}</span>
                <span v-else>{{ chartData[dataChart[currentChart].key]}}</span>
            </h2>
        </div>
        <div class="data-chart-charts">
            <UchartsRing  :ringData="ringData" :ringTitle="ringTitle" ></UchartsRing>
            <UchartsArea  class="charts-box" :areaData="areaData" ></UchartsArea>
        </div>
    </div>
    <!--认证统计数量 -->
    <div class="verify-data">
        <!--注册认证-->
        <div class="verify-item">
            <div class="verify-item-title">当前注册认证<p @click="toRegVerify(1,2)">更多<i class="el-icon-arrow-right" ></i></p></div>
            <div class="verify-item-content">
                <div @click="toRegVerify(1,2)">
                    <div class="verify-icon">
                        <i class="icon-hetong iconfont icon-img"></i>
                    </div>
                    <p>采购商</p>
                    <h2 :class="{'text-high':IndexData.reg_verify_arr.travel_reg_count>0}">{{IndexData.reg_verify_arr.travel_reg_count}}</h2>
                </div>
                <div @click="toRegVerify(1,3)">
                    <div class="verify-icon supplier-icon">
                        <i class="icon-youzhigongyingshang iconfont icon-img"></i>
                    </div>
                    <p>供应商</p>
                    <h2 :class="{'text-high':IndexData.reg_verify_arr.hotel_reg_count>0}">{{IndexData.reg_verify_arr.hotel_reg_count}}</h2>
                </div>
            </div>
        </div>  
        <!--当前编辑-->
        <div class="verify-item">
            <div class="verify-item-title">当前编辑认证<p @click="toRegVerify(2,2)">更多<i class="el-icon-arrow-right" ></i></p></div>
            <div class="verify-item-content">
                <div @click="toRegVerify(2,2)">
                    <div class="verify-icon">
                        <i class="icon-hetong iconfont icon-img"></i>
                    </div>
                    <p>采购商</p>
                    <h2 :class="{'text-high':IndexData.edit_verify_arr.travel_edit_count>0}">{{IndexData.edit_verify_arr.travel_edit_count}}</h2>
                </div>
                <div @click="toRegVerify(2,3)">
                    <div class="verify-icon supplier-icon">
                        <i class="icon-youzhigongyingshang iconfont icon-img"></i>
                    </div>
                    <p>供应商</p>
                    <h2 :class="{'text-high':IndexData.edit_verify_arr.hotel_edit_count>0}">{{IndexData.edit_verify_arr.hotel_edit_count}}</h2>
                </div>
            </div>
        </div>  
        <!--关联申请-->
        <div class="verify-item">
            <div class="verify-item-title">关联申请认证<p @click="correlation(2)">更多<i class="el-icon-arrow-right" ></i></p></div>
            <div class="verify-item-content">
                <div @click="correlation(2)">
                    <div class="verify-icon" style="background-color: #fdb462;">
                        <i class="icon-guanliancailiao iconfont icon-img"></i>
                    </div>
                    <p>加入申请</p>
                    <h2 :class="{'text-high':waitVerify.unionRecord_2_count>0}">{{waitVerify.unionRecord_2_count}}</h2>
                </div>
                <div @click="correlation(4)">
                    <div class="verify-icon" style="background-color: #ed777a;">
                        <i class="icon-jiechubangding iconfont icon-img"></i>
                    </div>
                    <p>解除申请</p>
                    <h2 :class="{'text-high':waitVerify.unionRecord_4_count>0}">{{waitVerify.unionRecord_4_count}}</h2>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
var dayjs = require('dayjs')
import {mapState, mapGetters, mapActions} from 'vuex'
import UchartsRing from '@/views/UserCenter/AdminHome/Components/UchartsRing'
import UchartsArea from '@/views/UserCenter/AdminHome/Components/UchartsAREA'
export default {
  name: '',
  components: {
    UchartsRing,
    UchartsArea,
  },
  props: {},
  data() {

    return {
        //头部概览数据
        headData: [
            {name:'今日活跃用户',key:'today_active_count',icon:'icon-huoyueyonghu-01'},
            {name:'今日注册用户',key:'today_reg_count',icon:'icon-xinzengyonghu-01'},
            {name:'今日发布订单',key:'today_send_count',icon:'icon-dingdan2'},
            {name:'今日成交订单',key:'today_deal_count',icon:'icon-yewu'},
            {name:'今日成交金额',key:'today_deal_price',icon:'icon-nstar-chengjiaojine',valueType: 'money'},
            {name:'今日线上支付',key:'today_price_pay',icon:'icon-caiwuguanli',valueType: 'money'},
        ],
         //统计数据概览图
         dataChart: [
            {name: '用户注册', key: 'reg_count'},
            {name: '门店认证', key: 'verify_count'},
            {name: '发布订单', key: 'send_count'},
            {name: '成交订单', key: 'deal_count'},
            {name: '成交金额', key: 'deal_price',valueType: 'money'},
            // {name: '线上支付', key: 'price_pay',valueType: 'money'},
            // {name: '线下支付', key: 'offline_pay', valueType: 'money'}
        ],
        //当前选择的统计数据
        currentChart:0,
        //数据表
        tableData: {},
        //统计数据概览图数据
        chartData: {},
        //统计数据时间范围数组
        timeRange: [],
        //时间范围选择器当前值
        timeRangeIndex: 0,
        //月份时间范围
        monthTimeRange: {},
        //曲线图数据
        areaData: {},
        //圆饼图数据
        ringData: {},
        ringTitle: {
            name:'',
            subtitle:0
        },
        monthRange: [],
    };
  },
  computed: {
     ...mapState(['IndexData','waitVerify']),
  },
  watch: {
  },
  created() {},
  mounted() {
    this.initial() 
  },
  methods: {
    ...mapActions(['getUserStateData','DataTotalYear']),
    async initial(){
        //
        let res = await this.getUserStateData({data:{}})
        if(res){
            res.today_price_pay = res.today_price_pay/100;
            this.chartData=res;
        }
        this.monthFormat();
        
    },
    //跳转注册和编辑认证
    toRegVerify(name,i){
        name = name==1?'VerifyStore':'VerifyStoreCheck'
        //跳转注册或分别
        let query={
            storeType:i,
            page:1,
        };
        this.$router.push({name:name,query:query})
    },
    //跳转关联申请
    correlation(i){
        let query={
            status:i,
            page:1,
        };
        this.$router.push({name:'PersonnelList',query:query})
    },
        //获取统计数据
    async getChartData(){
        let data=this.timeRangeIndex>-1?this.timeRange[this.timeRangeIndex]:this.monthTimeRange
        let res = await this.DataTotalYear({data:{
            ...data
        }});
        // console.log(res);
        if(res){
            this.tableData = res.date_info;
            this.changeChart(this.currentChart);
        }
    },
    //月份格式化
    monthFormat(date){
        // 1. 本月第一天 00:00:00 秒时间戳
        const monthStart = dayjs().startOf('month').startOf('day').valueOf() / 1000;

        // 2. 一年前的今天 00:00:00
        const oneYearAgo = dayjs().subtract(1, 'year').startOf('day').valueOf() / 1000;

        // 3. 半年前的今天 00:00:00
        const halfYearAgo = dayjs().subtract(6, 'month').startOf('day').valueOf() / 1000;

        // 4. 三个月前的今天 00:00:00
        const threeMonthAgo = dayjs().subtract(3, 'month').startOf('day').valueOf() / 1000
        let timeRange = [{
            name:'近1年',
            start_time:oneYearAgo,
            end_time:monthStart,
        },
        {
            name:'近6个月',
            start_time:halfYearAgo,
            end_time:monthStart,
        },
        {
            name:'近3个月',
            start_time:threeMonthAgo,
            end_time:monthStart,
        },
        ]
        this.timeRange = timeRange;
        this.getChartData();
    },
    //切换日期范围
    changeTimeRange(index){
        this.timeRangeIndex = index;
        this.monthTimeRange = {};
        this.getChartData();
    },
    //月份月份范围选择器
    handleMonthChange(val){
        if(val){
        // 选中月份的 当月1号 0点 秒时间戳
            const beginTs = dayjs(val[0]).startOf('month').startOf('day').valueOf() / 1000
            // 选中结束月份的 当月最后一天 23:59:59
            const endTs = dayjs(val[1]).startOf('month').startOf('day').valueOf() / 1000
            this.timeRangeIndex = -1;
            this.monthTimeRange={
                start_time:beginTs,
                end_time:endTs,
            }
        }else{
            this.timeRangeIndex = 0;
        }
        this.getChartData();
    },
    //切换统计数据
    changeChart(index){
        let i=this.tableData;
        this.currentChart = index;
        //曲线图数据
        let curveData = {
            categories: [],
            series: []
            };
        //圆饼数据
        let ringData = {series: [{data:[]}]},ringtitle={name:'',fontSize: 0},seriesList=[],num=0;
        //日期数据
        i.forEach(item => {
            curveData.categories.push(item.date);
        })
        //key数据
        let key = '', keyData1 = '',keyData2 = '',keyData3 = '',keyData4 = '',keynum= '';
        switch(index){
            case 0:
                ringtitle.name = '用户注册';
                seriesList = [
                    { name: "酒店销售" },
                    { name: "采购人员" }
                ];
                key = 'reg_verify';
                keynum = 'reg_count';
                keyData1 = 'reg_hotel_count';
                keyData2 = 'reg_travel_count';
            break;
            case 1:
                ringtitle.name = '门店认证';
                seriesList = [
                    { name: "供应商" },
                    { name: "采购商" }
                ];
                key = 'reg_verify';
                keynum = 'verify_count';
                keyData1 = 'verify_hotel_count';
                keyData2 = 'verify_travel_count';
            break;
            case 2:
                ringtitle.name = '发布订单';
                seriesList = [
                    { name: "确认单" },
                    { name: "定向单" },
                    { name: "询价单" },
                    { name: "匹配单" },
                ];
                key = 'order_count_info';
                keynum = 'send_count';
                keyData1 = 'confirm_count';
                keyData2 = 'appoint_count';
                keyData3 = 'ask_count';
                keyData4 = 'match_count';
            break;
            case 3:
                ringtitle.name = '成交订单';
                seriesList = [
                    { name: "确认单" },
                    { name: "定向单" },
                    { name: "询价单" },
                    { name: "匹配单" },
                ];
                key = 'order_count_info';
                keynum = 'deal_count';
                keyData1 = 'confirm_deal_count';
                keyData2 = 'appoint_deal_count';
                keyData3 = 'ask_deal_count';
                keyData4 = 'match_deal_count';
            break;
            case 4:
                ringtitle.name = '成交金额';
                seriesList = [
                    { name: "总金额" },
                    { name: "线上支付" },
                    { name: "线下支付" },
                ];
                key = 'order_price_info';
                keynum = 'deal_price';
                keyData1 = 'deal_price';
                keyData2 = 'price_pay';
                keyData3 = 'offline_pay';
            break;
            
        }
        seriesList.forEach(item => {
            curveData.series.push({
                name: item.name,
                data: []
            });
            ringData.series[0].data.push({
                name: item.name,
                value: 0
            });
        });
        i.forEach(item => {
            const val1 = Number(item[key][keyData1]);
            const val2 = Number(item[key][keyData2]);
            const val3 = Number(item[key][keyData3]);
            const val4 = Number(item[key][keyData4]);
            num += Number(item[key][keynum]);
            // 环形图累加
            ringData.series[0].data[0].value += val1;
            ringData.series[0].data[1].value += index==4?val2/100:val2;
            if(index>1){
                ringData.series[0].data[2].value += index==4?val3/100:val3;
                if(index!=4){
                    ringData.series[0].data[3].value += val4;
                }
            }
            // 曲线图追加
            curveData.series[0].data.push(val1);
            curveData.series[1].data.push(index==4?val2/100:val2);
            if(index>1){
                curveData.series[2].data.push(index==4?val3/100:val3);
                if(index!=4){
                    curveData.series[3].data.push(val4);
                }
            }
        });
        ringtitle.subtitle = num;
        this.areaData = JSON.parse(JSON.stringify(curveData));
        this.ringData = JSON.parse(JSON.stringify(ringData));
        this.ringTitle = ringtitle;
    }
  }
};
</script>

<style lang="scss" scoped>
    .admin-home{
        min-width: 1200px;
    }
    .head-data{
        width: 100%;
        display: flex;
        justify-content: space-between;
        
    }
    .head-item{
        background: #fff;
        width: 15.4%;
        height: 100px;
        border-radius: 6px;          
        position: relative;
        padding-top:20px;
        height: 80px;
    }
    .head-content{
        display: flex;
        justify-content:left;
        margin-left: 10%;
        align-items: center;
    }
    .head-icon{
        color: #fff;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 50%;
        // background: var(--smtc-color-primary);
        background: #e3effd;
        color: var(--smtc-color-primary);  
        margin-right: 10%;
        i{
            font-size: 24px;
        }
    }
    .head-name{
        display: flex;
        position: relative;
        z-index: 1;
    }
    .head-name-text{
        color: #999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 14px;
    }
    .head-value-text{
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        margin-top: 2px;
        color: #999;
    }
    .head-img{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 90%;
        margin:0 auto;
        margin-top: -40px;
        img{
            display: block;
            
        }
    }
    .data-chart{
        width: 98%;
        padding: 16px 1%;
        height: 500px;
        background: #fff;
        border-radius: 6px;
        margin-top: 20px;
        text-align: left;
    }

    .data-chart-title{
        font-weight: bold;
        font-size: 16px;
    }
    .data-chart-list{
        display: flex;
        margin-top: 14px;
        li{
            width:80px;
            border: 1px solid #e5e5e5;
            text-align: center;
            margin-right: 10px;
            padding: 8px 6px;
            border-radius: 4px;
            font-size: 12px;
            cursor: pointer;
            &:hover{
                background: var(--smtc-color-primary);
                color: #fff;
            }
        }
        .active{
            background: var(--smtc-color-primary);
            color: #fff;
        }
    }
    .data-chart-total{
        margin-top: 14px;
        p{
            color: #999;
            margin-bottom: 6px;
        }   
    }
    .data-chart-charts{
        display: flex;
        justify-content: space-between;
    }
    @media (max-width:1901px){
        .head-name{
            display: block;
        }
    }
    .verify-data{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .verify-item{
        background-color: #fff;
        width: 30%;
        border-radius: 4px;
        height: 180px;
        padding: 20px 1%;
    }
    .verify-item-title{
        display: flex;
        font-weight: bold;
        font-size: 16px;
        justify-content:space-between;
        p{
            font-size: 14px;
            color: #999;
            font-weight: normal;
            cursor: pointer;
        }
    }
    .verify-item-content{
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: 14px;
        >div{
            width: 50%;
            cursor: pointer;
            h2{
                margin-top:8px;
                color: #999;
            }
        }
    }
    .verify-icon{
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-radius: 50%;
        background: var(--smtc-color-primary);
        color: #fff;
        margin:14px auto;
        i{
            font-size: 28px;
        }
    }
    .supplier-icon{
        background: var(--smtc-color-green);
    }
    .text-high{
        color:#333 !important;
    }
    .data-chart-list-box{
        display: flex;
        justify-content:space-between;

    }
    .date-picker{
        margin-left: auto;
        margin-right: 16px;
        margin-top: 15px;
    }
</style>
